/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationEffectDateQuery from '../graphql/queries/GetSimulationEffectDateQuery.js';

const useGetSimulationEffectDateQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationEffectDateQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationEffectDate: R.omit(['__typename'], data?.getSimulationEffectDate_simulation_effect_date || {})
  };
};

export default useGetSimulationEffectDateQuery;
